export const FETCH_UPLOAD_IMAGE_REQUEST = 'FETCH_UPLOAD_IMAGE_REQUEST';
export const FETCH_UPLOAD_IMAGE_SUCCESS = 'FETCH_UPLOAD_IMAGE_SUCCESS';
export const FETCH_UPLOAD_IMAGE_FAILED = 'FETCH_UPLOAD_IMAGE_FAILED';

export const FETCH_UPDATE_IMAGE_REQUEST = 'FETCH_UPDATE_IMAGE_REQUEST';
export const FETCH_UPDATE_IMAGE_SUCCESS = 'FETCH_UPDATE_IMAGE_SUCCESS';
export const FETCH_UPDATE_IMAGE_FAILED = 'FETCH_UPDATE_IMAGE_FAILED';

export const FETCH_DELETE_IMAGE_REQUEST = 'FETCH_DELETE_IMAGE_REQUEST';
export const FETCH_DELETE_IMAGE_SUCCESS = 'FETCH_DELETE_IMAGE_SUCCESS';
export const FETCH_DELETE_IMAGE_FAILED = 'FETCH_DELETE_IMAGE_FAILED';

export const FETCH_IMAGES_REQUEST = 'FETCH_IMAGES_REQUEST';
export const FETCH_IMAGES_SUCCESS = 'FETCH_IMAGES_SUCCESS';
export const FETCH_IMAGES_FAILED = 'FETCH_IMAGES_FAILED';

export const RESET_UPLOAD_IMAGE_SUCCESS = 'FETCH_UPLOAD_IMAGE_FAILED';
